import { isEmpty, sumBy } from 'lodash';
import moment from 'moment';
import {
  findKeyValuePair, getIsPageNameDetail, getIsPageNameEdit, getIsPageNameEditDischarge, getIsPageNameReconsider,
  getExtensionFieldsValue,
} from '../modules/crm/inPatient/service/crmUtils';
import { BILL_DETAIL_ENUM, EXTENTION_KEYS, TREATMENT_TYPE } from '../shared/constants/crmConstants';
import { Payer } from '../shared/models/payer.model';
import { getDoctorMobileFormat, getMobileFormat } from './utility';

export const getMemberFormValueFromClaim = (claimDetails: any, allPayers: any[], inPatientNoFromHIS?: string, pathname?: string): any => {
  const {
    patientName: fullName, patientMobileNo, email: emailId, policyNo: policyNumber, memberId, healthId, pahchanNo: pehchanNo,
    employeeId, inPatientNo: claimDetailInPatientNumber, insurerName, policyHolderName: corporateName, payerActualId: payerId,
    productCode, hospitalNumber, isCovidCase, isMultipleSurgeries, retailOrCorporate,
    kycpan: kycPan, kycAdhaar, drivingLicense, voterId, insuranceCardNo: insuranceCardNumber, policyType: policyType, doctorMobileNo,
    presentComplaints, pastHistoryOfPresentAilment, attendantContactNumber, permanentDisability, isMLC, dateOfCommencement, isNewBornCase,
  } = claimDetails;

  const mobile = getMobileFormat(patientMobileNo);
  const payerUniqueId = productCode ? `${payerId}${productCode}` : `${payerId}`;

  const { name: payerName = '' } = allPayers.find(({ uniqueIdentifier }: Payer): boolean =>
    payerUniqueId === uniqueIdentifier) || {};
  const inPatientNumber = (pathname && getIsPageNameDetail(pathname) && !claimDetailInPatientNumber) ?
    '-' : inPatientNoFromHIS || claimDetailInPatientNumber;

  const formValues = {
    fullName, mobile, emailId, policyNumber, memberId, retailOrCorporate, kycPan, kycAdhaar, pehchanNo,
    employeeId, inPatientNumber, corporateName, corporateNameDropdown: corporateName, insurerName,
    payer: payerName, healthId, hospitalNumber, isMultipleSurgeries, isCovidCase, drivingLicense, voterId,
    doctorMobileNo, insuranceCardNumber, policyType, presentComplaints, pastHistoryOfPresentAilment, attendantContactNumber,
    permanentDisability, isMLC, dateOfCommencement, isNewBornCase,
  };

  return formValues;
};

export const getMemberFormValueFromBenef = (selectedBeneficiaryDetail: any = {}, allPayers: any[]): any => {
  const {payerId, productCode} = selectedBeneficiaryDetail;
  const payerUniqueId = productCode ? `${payerId}${productCode}` : `${payerId}`;
  const { name: payerName = '' } = allPayers.find(({ uniqueIdentifier }: Payer): boolean =>
    payerUniqueId === uniqueIdentifier) || {};
  return { ...selectedBeneficiaryDetail, payer: payerName } ;
};

const lowercaseKeys = (obj: any): any =>
  Object.keys(obj).reduce((acc: any, key: any): any => {
    acc[key.toLowerCase()] = obj[key];
    return acc;
  }, {});

  const lowercaseValues = (obj: any): any =>
  Object.keys(obj).reduce((acc: any, key: any): any => {
    acc[key] = obj[key].toLowerCase();
    return acc;
  }, {});

export const getBillDetailFormValue = (claimDetails: any, pathname: string): any => {
  let totalPackageCost = '0';
  const isPageNameDetail = getIsPageNameDetail(pathname);
  const isPageNameEdit = getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname);
  let packageArr: any[] = [];
  claimDetails = lowercaseKeys(claimDetails);
  const LC_BILL_DETAIL_ENUM = lowercaseValues(BILL_DETAIL_ENUM);
  const {
    [LC_BILL_DETAIL_ENUM.package]: Package,
    [LC_BILL_DETAIL_ENUM.otCharges]: otcharges,
    [LC_BILL_DETAIL_ENUM.consultation]: consultation,
    [LC_BILL_DETAIL_ENUM.investigation]: investigation,
    [LC_BILL_DETAIL_ENUM.surgeonAnesthetist]: surgeonanesthetist,
    [LC_BILL_DETAIL_ENUM.medicineConsumables]: medicineconsumables,
    [LC_BILL_DETAIL_ENUM.roomRent]: roomRent,
    [LC_BILL_DETAIL_ENUM.otherHospitalExpenses]: otherHospitalExpenses,
    [LC_BILL_DETAIL_ENUM.icuCharges]: icuCharges,
    [LC_BILL_DETAIL_ENUM.highRiskCharges]: highRiskCharges,
    [LC_BILL_DETAIL_ENUM.ambulance]: ambulance,
    [LC_BILL_DETAIL_ENUM.bloodCharges]: bloodCharges,
    [LC_BILL_DETAIL_ENUM.cathlab]: cathlab,
    [LC_BILL_DETAIL_ENUM.implantsCharges]: implantsCharges,
    [LC_BILL_DETAIL_ENUM.diabeticCharges]: diabeticCharges,
    [LC_BILL_DETAIL_ENUM.medicalEquimentCharges]: medicalEquimentCharges,
    [LC_BILL_DETAIL_ENUM.foodCharges]: foodCharges,
    [LC_BILL_DETAIL_ENUM.professionalCharges]: professionalCharges,
    [LC_BILL_DETAIL_ENUM.selectPackage]: selectPackage,
    [LC_BILL_DETAIL_ENUM.selectRoomRent]: selectRoomRent,
    [LC_BILL_DETAIL_ENUM.selectConsultation]: selectConsultation,
    [LC_BILL_DETAIL_ENUM.selectOT]: selectOT,
    [LC_BILL_DETAIL_ENUM.selectICU]: selectICU,
    [LC_BILL_DETAIL_ENUM.selectHighRisk]: selectHighRisk,
    [LC_BILL_DETAIL_ENUM.selectAnashthesia]: selectAnashthesia,
    [LC_BILL_DETAIL_ENUM.selectInvestigation]: selectInvestigation,
    [LC_BILL_DETAIL_ENUM.selectMedicine]: selectMedicine,
    [LC_BILL_DETAIL_ENUM.selectOtherExpenses]: selectOtherExpenses,
    [LC_BILL_DETAIL_ENUM.selectAmbulance]: selectAmbulance,
    [LC_BILL_DETAIL_ENUM.selectBloodCharges]: selectBloodCharges,
    [LC_BILL_DETAIL_ENUM.selectFoodCharges]: selectFoodCharges,
    [LC_BILL_DETAIL_ENUM.selectProfessionalFees]: selectProfessionalFees,
    [LC_BILL_DETAIL_ENUM.selectMedicalEquip]: selectMedicalEquip,
    [LC_BILL_DETAIL_ENUM.selectCathlab]: selectCathlab,
    [LC_BILL_DETAIL_ENUM.selectImplants]: selectImplants,
    [LC_BILL_DETAIL_ENUM.selectDiabetic]: selectDiabetic,
    [LC_BILL_DETAIL_ENUM.totalRent]: totalRent,
    [LC_BILL_DETAIL_ENUM.nursingCharge]: nursingCharge,
    [LC_BILL_DETAIL_ENUM.surgeonCharge]: surgeonCharge,
    [LC_BILL_DETAIL_ENUM.physicianCharge]: physicianCharge,
    [LC_BILL_DETAIL_ENUM.consumables]: consumables,
    [LC_BILL_DETAIL_ENUM.anesthetist]: anesthetist,
    [LC_BILL_DETAIL_ENUM.investigations]: investigations,
    [LC_BILL_DETAIL_ENUM.pharmacy]: pharmacy,
    [LC_BILL_DETAIL_ENUM.others]: others,
    [LC_BILL_DETAIL_ENUM.estimatedCost] : estimatedCost,
    [LC_BILL_DETAIL_ENUM.anhPackage] : anhPackage,

    selectedpackage: selectedPackage,
    claimedamount : claimedAmount,
  } = claimDetails;

  totalPackageCost = Package;
  if (selectedPackage?.length) {
    totalPackageCost = getTotalSum(selectedPackage);
    if (isPageNameDetail) {
      packageArr = selectedPackage
        .map(({ name }: any): string => name)
        .join(', ');
    } else if (isPageNameEdit) {
      packageArr = selectedPackage.map(({ value }: any): number => value);
    }
  }

  const formValues = {
    [BILL_DETAIL_ENUM.package]: totalPackageCost ? parseInt(totalPackageCost, 10) : undefined,
    [BILL_DETAIL_ENUM.otCharges]: otcharges ? parseInt(otcharges, 10) : undefined,
    [BILL_DETAIL_ENUM.totalRent]: totalRent ? parseInt(totalRent, 10) : undefined,
    [BILL_DETAIL_ENUM.nursingCharge]: nursingCharge ? parseInt(nursingCharge, 10) : undefined,
    [BILL_DETAIL_ENUM.surgeonCharge]: surgeonCharge ? parseInt(surgeonCharge, 10) : undefined,
    [BILL_DETAIL_ENUM.physicianCharge]: physicianCharge ? parseInt(physicianCharge, 10) : undefined,
    [BILL_DETAIL_ENUM.consumables]: consumables ? parseInt(consumables, 10) : undefined,
    [BILL_DETAIL_ENUM.anesthetist]: anesthetist ? parseInt(anesthetist, 10) : undefined,
    [BILL_DETAIL_ENUM.investigations]: investigations ? parseInt(investigations, 10) : undefined,
    [BILL_DETAIL_ENUM.pharmacy]: pharmacy ? parseInt(pharmacy, 10) : undefined,
    [BILL_DETAIL_ENUM.others]: others ? parseInt(others, 10) : undefined,
    [BILL_DETAIL_ENUM.consultation]: consultation ? parseInt(consultation, 10) : undefined,
    [BILL_DETAIL_ENUM.investigation]: investigation ? parseInt(investigation, 10) : undefined,
    [BILL_DETAIL_ENUM.surgeonAnesthetist]: surgeonanesthetist ? parseInt(surgeonanesthetist, 10) : undefined,
    [BILL_DETAIL_ENUM.medicineConsumables]: medicineconsumables ? parseInt(medicineconsumables, 10) : undefined,
    [BILL_DETAIL_ENUM.roomRent]: roomRent ? parseInt(roomRent, 0) : undefined,
    [BILL_DETAIL_ENUM.otherHospitalExpenses]: otherHospitalExpenses ? parseInt(otherHospitalExpenses, 10) : undefined,
    [BILL_DETAIL_ENUM.icuCharges]: icuCharges ? parseInt(icuCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.highRiskCharges]: highRiskCharges ? parseInt(highRiskCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.ambulance]: ambulance ? parseInt(ambulance, 10) : undefined,
    [BILL_DETAIL_ENUM.bloodCharges]: bloodCharges ? parseInt(bloodCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.cathlab]: cathlab ? parseInt(cathlab, 10) : undefined,
    [BILL_DETAIL_ENUM.implantsCharges]: implantsCharges ? parseInt(implantsCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.diabeticCharges]: diabeticCharges ? parseInt(diabeticCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.medicalEquimentCharges]: medicalEquimentCharges ? parseInt(medicalEquimentCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.foodCharges]: foodCharges ? parseInt(foodCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.professionalCharges]: professionalCharges ? parseInt(professionalCharges, 10) : undefined,
    [BILL_DETAIL_ENUM.selectPackage]: selectPackage ? selectPackage : null,
    [BILL_DETAIL_ENUM.selectRoomRent]: selectRoomRent ? selectRoomRent : null,
    [BILL_DETAIL_ENUM.selectConsultation]: selectConsultation ? selectConsultation : null,
    [BILL_DETAIL_ENUM.selectOT]: selectOT ? selectOT : null,
    [BILL_DETAIL_ENUM.selectICU]: selectICU ? selectICU : null,
    [BILL_DETAIL_ENUM.selectHighRisk]: selectHighRisk ? selectHighRisk : null,
    [BILL_DETAIL_ENUM.selectAnashthesia]: selectAnashthesia ? selectAnashthesia : null,
    [BILL_DETAIL_ENUM.selectInvestigation]: selectInvestigation ? selectInvestigation : null,
    [BILL_DETAIL_ENUM.selectMedicine]: selectMedicine ? selectMedicine : null,
    [BILL_DETAIL_ENUM.selectOtherExpenses]: selectOtherExpenses ? selectOtherExpenses : null,
    [BILL_DETAIL_ENUM.selectAmbulance]: selectAmbulance ? selectAmbulance : null,
    [BILL_DETAIL_ENUM.selectBloodCharges]: selectBloodCharges ? selectBloodCharges : null,
    [BILL_DETAIL_ENUM.selectFoodCharges]: selectFoodCharges ? selectFoodCharges : null,
    [BILL_DETAIL_ENUM.selectProfessionalFees]: selectProfessionalFees ? selectProfessionalFees : null,
    [BILL_DETAIL_ENUM.selectMedicalEquip]: selectMedicalEquip ? selectMedicalEquip : null,
    [BILL_DETAIL_ENUM.selectCathlab]: selectCathlab ? selectCathlab : null,
    [BILL_DETAIL_ENUM.selectImplants]: selectImplants ? selectImplants : null,
    [BILL_DETAIL_ENUM.selectDiabetic]: selectDiabetic ? selectDiabetic : null,
    [BILL_DETAIL_ENUM.estimatedCost] : estimatedCost  ? parseInt(estimatedCost, 10) : undefined,
    [BILL_DETAIL_ENUM.anhPackage] : anhPackage  ? parseInt(anhPackage, 10) : undefined,
    searchPackage: packageArr,
    claimedAmount,
  };

  return formValues;
};

export const getTreatmentDetailFormValue = (claimDetails: any, payerLookUp: any, uniqueIdentifier: any,
  getIsPageDetail: any, getIsPageEdit: any, isNormalPayer: any): any => {

  const newPackageNameField = claimDetails?.payerClaimExtensionFields?.find(
    (field: any): boolean => field?.fieldName === EXTENTION_KEYS.NEW_PACKAGE_NAME);
  const newPackageNameFieldValue = newPackageNameField?.fieldValue;
  if (newPackageNameFieldValue) {
    claimDetails.newPackageName = newPackageNameFieldValue;
  }

  const treatmentTypeField = claimDetails?.payerClaimExtensionFields?.find((field: any): any => field?.fieldName === TREATMENT_TYPE);
  const treatmentTypeFieldValue = treatmentTypeField?.fieldValue;

  if (treatmentTypeFieldValue) {
    claimDetails.treatmentType = treatmentTypeFieldValue;

  }
    if (claimDetails?.isMultipleSurgeries) {
    claimDetails?.isMultipleSurgeries === 'Yes' ? claimDetails.isMultipleSurgeries = 'Multiple' :
      claimDetails.isMultipleSurgeries = 'Single';
  }
  if (!isNormalPayer && (getIsPageEdit)) {
    // checking payerRoomType value is present in payerlookup or not
    if (claimDetails?.payerRoomType) {
      const { payerMasterValue: payerRoomTypeValue } =
        findKeyValuePair(payerLookUp?.[uniqueIdentifier]?.roomType, 'name', claimDetails?.payerRoomType) ||
        findKeyValuePair(payerLookUp?.[uniqueIdentifier]?.roomType, 'value', claimDetails?.payerRoomType) || {};
      if (payerRoomTypeValue === undefined) {
        claimDetails.payerRoomType = null;
      }
    }
  }
  const {
    diagnosis, proposedLineOfTreatment, procedure, automatedProcedure,
    dateOfAdmission, doctorName, doctorQualification, doctorMobileNo, doctorSpecialization,
    hospitalRoomType, payerRoomType, roomTypeText, docRegNo: doctorRegNo, icd10, icd10pcs,
    dateOfDischarge, isDeathCase, isDischargeCase, isCovidCase, isMultipleSurgeries, dateOfDiagnosis, speciality,
    sinceFeverDays, oxygenSaturationLevel, respiratoryRate, rpaAdmissionType, presentComplaints, pastHistoryOfPresentAilment,
    stateMedicalCouncil: stateMedicalCouncilText, newPackageName, internalRemark, routeOfAdministration,
    routeOfAdministration: routeOfAdministrationText, investigationDetails, hypertensionMonths, diabetesMonths, estimatedDays,
    ailmentDuration, anesthesiaType, stateMedicalCouncil, lossType, hospitalizationReason, systemOfMedicine, subGroup,
    sinceWhenDuration, sinceWhenPeriod, conditionOnDischarge, cataractOpearatedFor, dateOfSurgery, surgeryType, dateOfExpiry,
    permanentDisability, isMLC, dateOfCommencement, admissionType, payerClaimExtensionFields, treatmentType,
  } = claimDetails;

  const formattedDoctorNumber = getDoctorMobileFormat(doctorMobileNo);
  const dayCareType = getExtensionFieldsValue(EXTENTION_KEYS.DAY_CARE_TYPE, payerClaimExtensionFields);
  const cataractOperatedFor = getExtensionFieldsValue(EXTENTION_KEYS.CATARACT_OPERATED_FOR, payerClaimExtensionFields);
  const reasonForEnhancement = !isEmpty(getExtensionFieldsValue(EXTENTION_KEYS.REASON_FOR_ENHNACEMENT, payerClaimExtensionFields))
    ? JSON.parse(getExtensionFieldsValue(EXTENTION_KEYS.REASON_FOR_ENHNACEMENT, payerClaimExtensionFields) ?? '') : undefined;
    const reasonForReconsideration = getExtensionFieldsValue(EXTENTION_KEYS.REASON_FOR_RECONSDIERATION, payerClaimExtensionFields);
  const reasonForEnhancementDisplayValue = Array.isArray(reasonForEnhancement) ? reasonForEnhancement.join(', ') : reasonForEnhancement;
  const formValues = {
    dateOfAdmission, dateOfDischarge, diagnosis, diagnosisDropDown: diagnosis, doctorName, doctorRegNo, automatedProcedure,
    doctorQualification, doctorQualificationDropDown: doctorQualification, doctorMobileNo: formattedDoctorNumber,
    doctorSpecialization: doctorSpecialization?.payerMasterValue,
    proposedLineOfTreatment, procedure, procedureDropDown: procedure, payerRoomType, hospitalRoomType,
    roomTypeText, icd10, icd10pcs, isDeathCase, isDischargeCase,
    isCovidCase, isMultipleSurgeries, dateOfDiagnosis, speciality, permanentDisability, isMLC, dateOfCommencement,
    sinceFeverDays, oxygenSaturationLevel, respiratoryRate, rpaAdmissionType: rpaAdmissionType || admissionType,
    presentComplaints, pastHistoryOfPresentAilment,
    stateMedicalCouncilText, newPackageName, internalRemark, routeOfAdministration, admissionType,
    routeOfAdministrationText, investigationDetails, hypertensionMonths, diabetesMonths, estimatedDays, ailmentDuration, anesthesiaType,
    stateMedicalCouncil, lossType, hospitalizationReason, systemOfMedicine,
    subGroup, sinceWhenDuration, sinceWhenPeriod, conditionOnDischarge, cataractOpearatedFor, dateOfSurgery, surgeryType, dateOfExpiry,
    stayLength : getIsPageDetail ? [dateOfAdmission, ' - ' , dateOfDischarge] :
    dateOfAdmission ? [dateOfAdmission, dateOfDischarge] : undefined, treatmentType, dayCareType, cataractOperatedFor,
    reasonForEnhancement: reasonForEnhancementDisplayValue, reasonForReconsideration,
  };
  return formValues;
};

export const getOtherMemberDetailFormValues = (claimDetails: any, selectedBeneficiaryDetail: any = {}): any => {
  if (claimDetails?.mediclaimOthers) {
    claimDetails?.mediclaimOthers === 'true' ? claimDetails.mediclaimOthers = 'Yes' : claimDetails.mediclaimOthers = 'No';
  }
  const { govtScheme = {}, patientGender: memberGenderSex, patientAge: memberAge, dateOfBirth, familyPhysicianName,
    physicianMobileNumber, attendingRelativeMobile, mediclaimOthers, otherMediclaim, certificateNumber,
         emergencyContactPerson: memberEmergencyContactPerson, relation, panCardNumber } = claimDetails;
  const { designation, aadharNo, unitName, employeeName, placeOfPosting, district, corporate_name } = govtScheme;

  // TODO:: Work on Relation
  const formValues = {
    memberGenderSex, memberGenderSexRadio: memberGenderSex, memberGenderSelect: memberGenderSex, memberAge, district, aadharNo,
    designation, relation, unitName, employeeName, placeOfPosting, dateOfBirth, corporate_name, familyPhysicianName, physicianMobileNumber,
    attendingRelativeMobile, mediclaimOthers, otherMediclaim, relationTextInput: relation,
     certificateNumber, memberEmergencyContactPerson, panNumber: panCardNumber,
  };

  return formValues;
};

export const getGeneralFormValues = (claimDetail: any, pathname: string, inPatientNoFromHIS?: string): any => {
  const { claimedAmount, dateOfAdmission, dateOfDischarge, patientName: fullName, policyNo: policyNumber,
    pahchanNo: pehchanNo, admissionType, email: emailId,
    patientAge: memberAge, diagnosis, employeeId, corporateName,
    proposedLineOfTreatment, payerRoomType, docRegNo: doctorRegNo,
    procedure, memberId, patientMobileNo, inPatientNo: claimDetailInPatientNumber, doctorName, isNewBornCase,
     insurerName, payerClaimExtensionFields} = claimDetail;
  const mobile = getMobileFormat(patientMobileNo);
  const formattedDOA = dateOfAdmission ? moment(dateOfAdmission).format('DD MMM YYYY') : null;
  const formattedDOD = dateOfDischarge ? moment(dateOfDischarge).format('DD MMM YYYY') : null;
  const inPatientNumber = inPatientNoFromHIS || claimDetailInPatientNumber;
  const otherFormValues = {
    claimedAmount: (!getIsPageNameEdit(pathname) && !getIsPageNameEditDischarge(pathname) &&
      !getIsPageNameReconsider(pathname)) ? claimedAmount : undefined,
    lengthOfStay: [
      getIsPageNameDetail(pathname) ? dateOfAdmission : moment(dateOfAdmission),
      getIsPageNameDetail(pathname) ? dateOfDischarge : moment(dateOfDischarge),
    ], fullName, policyNumber, procedure, memberId, mobile, inPatientNumber, pehchanNo, admissionType,
    doctorName, memberAge, diagnosis, emailId, employeeId, corporateName, proposedLineOfTreatment, payerRoomType,
    doctorRegNo, isNewBornCase, insurerName,  // mapping insuer name from claim details to show in form
    stayLength: getIsPageNameDetail(pathname)
    ? [formattedDOA, ' - ', formattedDOD]
    : dateOfAdmission ? [dateOfAdmission, dateOfDischarge] : undefined,
    dayCareType: getExtensionFieldsValue(EXTENTION_KEYS.DAY_CARE_TYPE, payerClaimExtensionFields),
  };
  const billDetail = getBillDetailFormValue(claimDetail, pathname);
  const formValues = {...otherFormValues, ...billDetail};
  return formValues;
};

export const getTotalSum = (packages: any[], dateOfAdmission?: moment.Moment, dateOfDischarge?: moment.Moment,
  dialysis?: number): string => {
  let noOfDays = 1;
  if (dateOfAdmission && dateOfDischarge) {
    noOfDays = dateOfDischarge.diff(dateOfAdmission, 'days') + 1;
    if (noOfDays < 1) {
      noOfDays = 1;
    }
  } // multiply the package amount selected only for dialysis cases
  return sumBy(packages, ({ packageCost, is_Per_Day_Eligible_Package, package_Name }: any): number => {
    const dialysisPackage = (package_Name?.toLowerCase()?.includes('dialysis'));
    const cost = parseInt(is_Per_Day_Eligible_Package ? packageCost * noOfDays : packageCost, 10) *
    (dialysisPackage ? (dialysis || 1) : 1);
    return cost;
   })?.toString();
};
